module.exports = __webpack_public_path__ + "static/img/active2.6c8a79b.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/active2.png
// module id = nkKW
// module chunks = 1